import * as React from "react";
import classNames from "classnames";
import { $, merge, media } from "glamor";
import { theme } from "styles/theme";
import FlatButton from "material-ui/FlatButton";

interface IProps {
    icon: any;
    label: string;
    onClick: React.MouseEventHandler;
    className?: string;
    active?: boolean;
    disabled?: boolean;
    dataTest?: string;
    dataView?: string;
    svgStroke?: boolean;
}

const Button: React.FunctionComponent<IProps> = ({
    icon,
    label,
    onClick,
    className,
    active,
    disabled,
    dataView,
    dataTest,
    svgStroke,
}) => {
    const styles = React.useMemo(
        () =>
            merge(
                $(" .toolbarButton", {
                    minWidth: "30px !important",
                    height: "42px !important",
                    lineHeight: "14px !important",
                    borderRadius: "4px !important",
                    marginTop: "2px !important",
                    marginLeft: "20px !important",
                }),
                $(" .toolbarButton > div > span:last-child", {
                    lineHeight: "14px",
                    display: "block",
                    textAlign: "center",
                    fontSize: "10px !important",
                    fontWeight: "bold",
                    padding: "2px 0 0 !important",
                }),
                $(" .toolbarButton svg", {
                    margin: "0 !important",
                    height: "18px !important",
                    width: "18px !important",
                    verticalAlign: "middle",
                }),
                $(" .toolbarButton.svgStroke svg *", {
                    stroke: `${theme.palette.grey} !important`,
                }),
                $(" .toolbarButton.svgStroke.stateful.active svg *", {
                    stroke: `${theme.palette.darkGrey} !important`,
                }),
                $(" .toolbarButton.svgFill svg *", {
                    fill: `${theme.palette.grey} !important`,
                }),
                $(" .toolbarButton.svgFill.stateful.active svg *", {
                    fill: `${theme.palette.darkGrey} !important`,
                }),
                media(
                    "(max-width: 600px)",
                    $(" .spacer", {
                        display: "none",
                    }),
                    $(" .toolbarButton", {
                        minWidth: "24px !important",
                    }),
                    $(" .toolbarButton  > div > span:last-child", {
                        display: "none",
                    })
                )
            ),
        []
    );

    return (
        <React.Fragment>
            <div {...styles}>
                <FlatButton
                    className={classNames("toolbarButton", className, {
                        stateful: active !== undefined,
                        active,
                        disabled,
                        svgStroke,
                        svgFill: !svgStroke,
                    })}
                    onClick={onClick}
                    icon={icon}
                    label={label}
                    data-test={dataTest}
                    data-view={dataView}
                />
            </div>
        </React.Fragment>
    );
};

export default Button;
